import {
  SmartToy as SmartToyIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { isBoolean } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UserRole } from 'enums';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { PayinOrder } from 'types';

type Props = {
  order: PayinOrder;
};

export const AutomationStatus: React.FC<Props> = ({ order }) => {
  const { t: tCommon } = useTranslation();

  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.order_automation',
  });

  const { isTrader } = useUser();

  if (!isBoolean(order.completedByAutomation)) {
    return null;
  }

  if (order.completedByAutomation) {
    return (
      <Tooltip title={t('closed_by_automation')}>
        <SmartToyIcon color="success" />
      </Tooltip>
    );
  }

  if (order.completedBy) {
    return (
      <Tooltip
        title={
          isTrader
            ? t('closed_manually')
            : `${t(`closed_manually`)}: ${order.completedBy.name} ${
                order.completedBy.role
                  ? `(${tCommon(`role.${order.completedBy.role}`)})`
                  : ``
              }`
        }
      >
        <PersonIcon
          color={
            order.completedBy?.role === UserRole.Trader ? 'primary' : 'disabled'
          }
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('closed_manually')}>
      <PersonIcon color="disabled" />
    </Tooltip>
  );
};
